import React from 'react';
import PropTypes from 'prop-types';

const formatCurrency = (value) => {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  return `$${(value / 1000).toFixed(0)}k`;
};

const ConsiderationBreakdownBar = ({
  grossConsideration,
  cashAtClosing,
  vendorTakeback,
  earnout,
  escrow,
  className,
}) => {
  const safeTotal = grossConsideration > 0 ? grossConsideration : 1;
  const segments = [
    {
      label: 'Cash at Closing',
      amount: cashAtClosing,
      color: 'bg-[hsl(var(--succeedo-orange))]',
      pct: (cashAtClosing / safeTotal) * 100,
    },
    {
      label: 'Vendor Takeback',
      amount: vendorTakeback,
      color: 'bg-amber-500 dark:bg-amber-600',
      pct: (vendorTakeback / safeTotal) * 100,
    },
    {
      label: 'Earnout',
      amount: earnout,
      color: 'bg-yellow-500 dark:bg-yellow-600',
      pct: (earnout / safeTotal) * 100,
    },
    {
      label: 'Escrow',
      amount: escrow,
      color: 'bg-[hsl(var(--muted-foreground))]/40',
      pct: (escrow / safeTotal) * 100,
    },
  ].filter((s) => s.amount > 0);

  return (
    <div className={`space-y-3 ${className || ''}`}>
      <div className="relative h-12 rounded-[8px] overflow-hidden flex">
        {segments.map((segment) => (
          <div
            key={segment.label}
            className={`relative ${segment.color}`}
            style={{ width: `${segment.pct}%` }}>
            {segment.pct > 12 && (
              <div className="absolute inset-0 flex items-center justify-center text-white text-[11px] font-medium">
                {formatCurrency(segment.amount)}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3">
        {segments.map((segment) => (
          <div key={segment.label} className="flex items-center gap-2">
            <div className={`w-3 h-3 rounded-sm flex-shrink-0 ${segment.color}`} />
            <div className="flex-1 min-w-0">
              <div className="text-[11px] text-[hsl(var(--muted-foreground))]">{segment.label}</div>
              <div className="text-[13px] text-[hsl(var(--foreground))] font-medium">
                {formatCurrency(segment.amount)} · {segment.pct.toFixed(0)}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ConsiderationBreakdownBar.propTypes = {
  grossConsideration: PropTypes.number.isRequired,
  cashAtClosing: PropTypes.number.isRequired,
  vendorTakeback: PropTypes.number,
  earnout: PropTypes.number,
  escrow: PropTypes.number,
  className: PropTypes.string,
};

ConsiderationBreakdownBar.defaultProps = {
  vendorTakeback: 0,
  earnout: 0,
  escrow: 0,
  className: '',
};

export default ConsiderationBreakdownBar;
